import { render, staticRenderFns } from "./TileQuantity.vue?vue&type=template&id=63e4c18c&"
import script from "./TileQuantity.vue?vue&type=script&lang=ts&"
export * from "./TileQuantity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductDiscountLabels: require('/home/vsts/work/1/a/NuxtApp/components/product/DiscountLabels.vue').default,ProductLabel: require('/home/vsts/work/1/a/NuxtApp/components/product/Label.vue').default,ProductTags: require('/home/vsts/work/1/a/NuxtApp/components/product/Tags.vue').default,ProductVariantOptions: require('/home/vsts/work/1/a/NuxtApp/components/product/VariantOptions.vue').default,ProductPrice: require('/home/vsts/work/1/a/NuxtApp/components/product/Price.vue').default,BaseSelect: require('/home/vsts/work/1/a/NuxtApp/components/base/Select.vue').default,ProductListerFavorite: require('/home/vsts/work/1/a/NuxtApp/components/product/lister/Favorite.vue').default,ProductAddToCartButton: require('/home/vsts/work/1/a/NuxtApp/components/product/AddToCartButton.vue').default,BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default})
